import { useState, useEffect } from 'react';
import useStyle from './index.styles';
import { Button, Modal } from 'antd';
import { useTranslation } from 'react-i18next';
import { XmarkSolid } from '../../utils/icons';
import { useIsMobile } from '../../utils/hooks';
import { useNavigate } from 'react-router-dom';
import AddCommentForm from '../AddCommentForm';

const AddCommentModal = ({
  deceasedName,
  isMemorialCreator,
  memorialId,
  reloadMemorial,
}: {
  deceasedName: string;
  isMemorialCreator: boolean;
  memorialId: string;
  reloadMemorial: () => void;
}) => {
  const classes = useStyle();
  const [show, setShow] = useState(false);
  const [resetValues, setResetValues] = useState<boolean>(false);

  const { t } = useTranslation();
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  const handleOk = () => {
    setResetValues(true);
  };

  const handleCancel = () => {
    setResetValues(true);
  };

  useEffect(() => {
    if (resetValues) {
      setShow(false);
      setResetValues(false);
    }
  }, [resetValues]);

  return (
    <>
      <Button
        type="primary"
        className={`mb-[16px] mt-[8px] w-full md:w-[initial] ${isMobile ? 'small' : ''}`}
        onClick={() =>
          isMobile
            ? navigate(
                `/home/add-comment/${memorialId}?name=${deceasedName}&isMemorialCreator=${isMemorialCreator}`
              )
            : setShow(true)
        }
      >
        {t('addCommentModal.addAComment')}
      </Button>
      <Modal
        title={null}
        open={show}
        onOk={handleOk}
        onCancel={handleCancel}
        width={1034}
        className={classes.modal}
        footer={null}
        closeIcon={<XmarkSolid />}
        centered
      >
        <AddCommentForm
          deceasedName={deceasedName}
          isMemorialCreator={isMemorialCreator}
          resetValues={resetValues}
          onClose={() => {
            isMemorialCreator && reloadMemorial();
            handleCancel();
          }}
        />
      </Modal>
    </>
  );
};

export default AddCommentModal;
